// // // import React, { useState } from 'react';
// // // import {
// // //   Card, CardContent, TextField, Button, IconButton, Avatar, Box, Typography
// // // } from '@mui/material';
// // // import ImageIcon from '@mui/icons-material/Image';
// // // import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
// // // import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';

// // // const PostBox = () => {
// // //   const [postText, setPostText] = useState('');
// // //   const [imagePreview, setImagePreview] = useState(null);

// // //   const handleImageUpload = (e) => {
// // //     const file = e.target.files[0];
// // //     if (file) {
// // //       setImagePreview(URL.createObjectURL(file));
// // //     }
// // //   };

// // //   const handlePost = () => {
// // //     console.log('Post:', postText);
// // //     console.log('Image:', imagePreview);
// // //     setPostText('');
// // //     setImagePreview(null);
// // //   };

// // //   return (
// // //     <Card sx={{ maxWidth: 500, margin: 'auto', mt: 2, borderRadius: 2 }}>
// // //       <CardContent>
// // //         <Typography variant="h6" gutterBottom>Post Something</Typography>
// // //         <Box display="flex" alignItems="center" gap={1}>
// // //           <Avatar src="https://randomuser.me/api/portraits/men/11.jpg" />
// // //           <TextField
// // //             fullWidth
// // //             placeholder="What's on your mind?"
// // //             variant="standard"
// // //             value={postText}
// // //             onChange={(e) => setPostText(e.target.value)}
// // //             InputProps={{ disableUnderline: true }}
// // //           />
// // //           <input
// // //             accept="image/*"
// // //             id="upload-image"
// // //             type="file"
// // //             style={{ display: 'none' }}
// // //             onChange={handleImageUpload}
// // //           />
// // //           <label htmlFor="upload-image">
// // //             <IconButton component="span">
// // //               <ImageIcon />
// // //             </IconButton>
// // //           </label>
// // //         </Box>

// // //         {imagePreview && (
// // //           <Box mt={2}>
// // //             <img src={imagePreview} alt="Preview" width="100%" style={{ borderRadius: 8 }} />
// // //           </Box>
// // //         )}

// // //         <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
// // //           <Button variant="contained" color="primary" onClick={handlePost}>Post</Button>
// // //           <Box>
// // //             <IconButton><ThumbUpAltOutlinedIcon /></IconButton>
// // //             <IconButton><ChatBubbleOutlineOutlinedIcon /></IconButton>
// // //           </Box>
// // //         </Box>
// // //       </CardContent>
// // //     </Card>
// // //   );
// // // };

// // // export default PostBox;


// // import React, { useState } from 'react';
// // import {
// //   Card, CardContent, TextField, Button, IconButton, Avatar, Box, Typography,
// //   Divider
// // } from '@mui/material';
// // import ImageIcon from '@mui/icons-material/Image';
// // import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
// // import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
// // import profile_image from "../../Assets/Media.jpg"
// // import { TbHeartFilled } from "react-icons/tb";
// // import { VscHeart } from "react-icons/vsc";



// // const PostBox = () => {
// //   const [postText, setPostText] = useState('');
// //   const [imagePreview, setImagePreview] = useState(null);
// //   const [posts, setPosts] = useState([]);

// //   const handleImageUpload = (e) => {
// //     const file = e.target.files[0];
// //     if (file) {
// //       setImagePreview(URL.createObjectURL(file));
// //     }
// //   };

// //   const handlePost = () => {
// //     const newPost = {
// //       id: Date.now(),
// //       text: postText,
// //       image: imagePreview,
// //     };
// //     setPosts([newPost, ...posts]); // Add new post at the top
// //     setPostText('');
// //     setImagePreview(null);
// //   };

// //   return (
// //     <Box sx={{
// //       // maxWidth: 550,
// //       margin: 'auto',
// //       mt: 2,
// //       boxShadow: 4
// //     }}>

// //       {/* Input Box */}
// //       <Card sx={{ borderRadius: 2 }}>
// //         <CardContent>
// //           <Typography variant="h6" gutterBottom>Post Something</Typography>
// //           <Divider />
// //           <Box display="flex" alignItems="center" gap={1} mt={1}>
// //             <Avatar src={profile_image}
// //               sx={{
// //                 border: "1px solid gray",
// //                 "& .MuiAvatar-img": {
// //                   objectFit: "contain"
// //                 }
// //               }} />
// //             <TextField
// //               sx={{ border: "1px solid #f4f2ee", p: 1 }}
// //               fullWidth
// //               placeholder="What's on your mind?"
// //               variant="standard"
// //               value={postText}
// //               onChange={(e) => setPostText(e.target.value)}
// //               InputProps={{ disableUnderline: true }}
// //             />
// //             <input
// //               accept="image/*"
// //               id="upload-image"
// //               type="file"
// //               style={{ display: 'none' }}
// //               onChange={handleImageUpload}
// //             />
// //             <label htmlFor="upload-image">
// //               <IconButton component="span">
// //                 <ImageIcon />
// //               </IconButton>
// //             </label>
// //           </Box>

// //           {imagePreview && (
// //             <Box mt={2}>
// //               <img src={imagePreview} alt="Preview" width="100%" style={{ borderRadius: 8 }} />
// //             </Box>
// //           )}

// //           <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
// //             <Button
// //               variant="contained"
// //               color="primary"
// //               onClick={handlePost}
// //               disabled={!postText && !imagePreview}
// //             >
// //               Post
// //             </Button>
// //             {/* <Box>
// //               <IconButton><ThumbUpAltOutlinedIcon /></IconButton>
// //               <IconButton><ChatBubbleOutlineOutlinedIcon /></IconButton>
// //             </Box> */}
// //           </Box>
// //         </CardContent>
// //       </Card>

// //       {/* Render Submitted Posts */}
// //       {posts.map((post) => (
// //         <Card key={post.id} sx={{ mt: 2, borderRadius: 2 }}>
// //           <CardContent>
// //             <Box display="flex" alignItems="center" gap={1} mb={1}>
// //               {/* <Avatar src="https://randomuser.me/api/portraits/men/11.jpg" /> */}
// //               <Avatar src={profile_image}
// //                 sx={{
// //                   border: "1px solid gray",
// //                   "& .MuiAvatar-img": {
// //                     objectFit: "contain"
// //                   }
// //                 }} />
// //               <Typography fontWeight={600}>John Doe</Typography>
// //             </Box>
// //             <Divider />

// //             <Typography>{post.text}</Typography>
// //             {post.image && (
// //               <Box mt={1}>
// //                 <img src={post.image} alt="Post" width="100%" style={{ borderRadius: 8 }} />
// //               </Box>
// //             )}
// //             <Box mt={2} display="flex" gap={1}>
// //               <IconButton sx={{fontSize:"16px"}}><VscHeart style={{fontSize:"20px"}}/> Like</IconButton>
// //               <IconButton sx={{fontSize:"16px"}}><ChatBubbleOutlineOutlinedIcon style={{fontSize:"20px"}}/> Comment</IconButton>
// //             </Box>
// //           </CardContent>
// //         </Card>
// //       ))}
// //     </Box>
// //   );
// // };

// // export default PostBox;




// import React, { useEffect, useState } from 'react';
// import {
//   Card, CardContent, TextField, Button, IconButton, Avatar, Box, Typography,
//   Divider
// } from '@mui/material';
// import ImageIcon from '@mui/icons-material/Image';
// import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
// import profile_image from "../../../Assets/Media.jpg"
// import { VscHeart } from "react-icons/vsc";
// import { FaHeart } from "react-icons/fa";
// import { useDispatch, useSelector } from 'react-redux';
// import actions from '../../../ReduxStore/actions';
// import { toast } from 'react-toastify';
// import FullPageLoader from '../../../Components/FullPageLoader/FullPageLoader';
// import Slider from 'react-slick';
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";



// const PostBox = () => {
//   const [postText, setPostText] = useState('');
//   const [imagePreview, setImagePreview] = useState(null);
//   const [posts, setPosts] = useState([]);
//   const [replyingToIndex, setReplyingToIndex] = useState(null);
//   console.log(postText, "postText")
//   console.log(imagePreview, "postText 1")

//   const { MyPostForusers } = useSelector(state => state?.MyPostForusers);
//   const { MyPostForUsersGetAll } = useSelector(state => state?.MyPostForUsersGetAll);
//   console.log(MyPostForusers, "postsForUserpostsForUser 22")

//   console.log(MyPostForUsersGetAll, "postsForUserpostsForUser 11")

//   const [uploadedFiles, setUploadedFiles] = useState([])
//   console.log(uploadedFiles, 'uploadedFiless')
//   console.log(uploadedFiles?.length, 'uploadedFiles couunt')
//   console.log(uploadedFiles[0]?.type, 'uploadedFiles type')



//   // const handleImageUpload = (e) => {
//   //   const file = e.target.files[0];
//   //   if (file) {
//   //     // setImagePreview(URL.createObjectURL(file));
//   //     setImagePreview(file);

//   //   }
//   // };


//   const handleImageUpload = (e) => {
//     const files = Array.from(e.target.files);
//     setUploadedFiles(prev => [...prev, ...files]);
//   };

//   const dispatch = useDispatch()
//   const [loading, setLoading] = useState(false);

//   const alumni_user_id = sessionStorage.getItem("alumni_user_id")
//   const blobUrlToFile = async (blobUrl, fileName) => {
//     const response = await fetch(blobUrl);
//     const blob = await response.blob();
//     return new File([blob], fileName, { type: blob.type });
//   };



//   useEffect(() => {
//     // const tempArr = [];
//     const fetchData = async () => {
//       const data1 = {
//         data: {},
//         method: "get",
//         apiName: `mypost/${alumni_user_id}`,
//       };
//       dispatch(actions.MYPOSTFORUSERGETALL(data1));

//     }
//     fetchData()
//   }, [MyPostForusers]);




//   const handlePost = async () => {
//     setLoading(true)
//     const formData = new FormData();
//     formData.append("postcomment", postText);
//     // if (URL.createObjectURL(imagePreview)?.startsWith("blob:")) {
//     //   // New uploaded file (blob)
//     //   try {
//     //     const file = await blobUrlToFile(URL.createObjectURL(imagePreview));
//     //     console.log("Appending new file:", file);
//     //     formData.append(`media[]`, file);
//     //   } catch (error) {
//     //     console.error("Error converting blob to file:", error);
//     //   }
//     // }
//     uploadedFiles.forEach((file) => {
//       formData.append(`media[]`, file);
//     });
//     const data1 = {
//       data: formData,
//       method: "post",
//       apiName: `mypost/${alumni_user_id}`,
//       isFormData: true,
//     };

//     const responseData = await dispatch(actions.MYPOSTFORUSER(data1));
//     console.log(responseData, "responseDtata")
//     if (responseData?.payload?.message === "Post added successfully.") {
//       setLoading(false);
//       console.log("itswork")
//       // resetForm();
//       // setUploadedFile([]); // Assuming this manages UI state
//       // handleAddFormGoBackButton();
//       // setTimeout(() => {
//       toast.success(`Post added successfully.`);
//       setUploadedFiles([]);
//       // }, 1500);
//     } else {
//       setLoading(false);
//       toast.error(responseData?.payload?.message);
//     }


//     const newPost = {
//       id: Date.now(),
//       text: postText,
//       image: imagePreview,
//       likes: 0,
//       comments: [],
//       showCommentBox: false,
//     };
//     setPosts([newPost, ...posts]); // Add new post at the top
//     setPostText('');
//     setImagePreview(null);
//   };

//   const postsForUser = MyPostForUsersGetAll?.data?.map((data, index) => ({

//     id: data?.id,
//     text: data?.postcomment,
//     image: data?.media,
//     // likes:
//     likes: 0,
//     comments: [],
//     showCommentBox: false



//   }))
//   console.log(MyPostForUsersGetAll, "postsForUserpostsForUser 11")


//   console.log(postsForUser, "postsForUser")

//   const settings = {
//     dots: true,
//     // infinite: true,
//     speed: 500,
//     height: 450,
//     slidesToShow: 1,
//     slidesToScroll: 1
//   };



//   // const handleLike = (postId) => {
//   //   setPosts(posts.map(post =>
//   //     post.id === postId ? { ...post, likes: post.likes + 1 } : post
//   //   ));
//   // };


//   // const [posts, setPosts] = useState([
//   //   { id: 1, likes: 0 },
//   //   { id: 2, likes: 5 },
//   //   // ...other posts
//   // ]);
//   const [likedPosts, setLikedPosts] = useState([]); // track liked post IDs

//   const handleLike = (postId) => {
//     if (!likedPosts.includes(postId)) {
//       setPosts(posts.map(post =>
//         post.id === postId ? { ...post, likes: post.likes + 1 } : post
//       ));
//       setLikedPosts([...likedPosts, postId]); // add to liked posts
//     }
//   };

//   const toggleCommentBox = (postId) => {
//     setPosts(posts.map(post =>
//       post.id === postId ? { ...post, showCommentBox: !post.showCommentBox } : post
//     ));
//   };

//   // const handleAddComment = (postId, commentText) => {
//   //   setPosts(posts.map(post =>
//   //     post.id === postId
//   //       ? { ...post, comments: [...post.comments, commentText] }
//   //       : post
//   //   ));
//   // };

//   const handleAddComment = (postId, commentText, parentIndex = null) => {
//     setPosts(posts.map(post => {
//       if (post.id !== postId) return post;

//       if (parentIndex === null) {
//         // Add new top-level comment
//         return {
//           ...post,
//           comments: [...post.comments, { text: commentText, profile_image: profile_image, replies: [] }]
//         };
//       } else {
//         // Add reply to existing comment
//         const updatedComments = [...post.comments];
//         updatedComments[parentIndex].replies.push(commentText);
//         return {
//           ...post,
//           comments: updatedComments
//         };
//       }
//     }));
//   };


//   // const images = post?.image?.images || [];
//   // const videos = post?.image?.videos || [];
//   // const documents = post?.image?.documents || [];

//   // const totalMediaCount = images.length + videos.length + documents.length;



//   return (
//     <Box sx={{ margin: 'auto', mt: 2, boxShadow: 4 }}>

//       {/* Input Box */}
//       {loading && <FullPageLoader />}

//       <Card sx={{ borderRadius: 2 }}>
//         <CardContent>
//           <Typography variant="h6" gutterBottom>Post Something</Typography>
//           <Divider />
//           <Box display="flex" alignItems="center" gap={1} mt={1}>
//             <Avatar src={profile_image}
//               sx={{
//                 border: "1px solid gray",
//                 "& .MuiAvatar-img": {
//                   objectFit: "contain"
//                 }
//               }} />
//             {/* <TextField
//               sx={{ border: "1px solid #f4f2ee", p: 1 }}
//               fullWidth
//               placeholder="What's on your mind?"
//               variant="standard"
//               value={postText}
//               onChange={(e) => setPostText(e.target.value)}
//               InputProps={{ disableUnderline: true }}
//             /> */}

//             <Formik
//               initialValues={{ postText: '' }}
//               onSubmit={(values) => {
//                 console.log('Submitted values:', values);
//               }}
//             >
//               {({ values, handleChange }) => (
//                 <Form>
//                   <TextField
//                     name="postText"
//                     fullWidth
//                     placeholder="What's on your mind?"
//                     variant="standard"
//                     sx={{ border: '1px solid #f4f2ee', p: 1 }}
//                     value={values.postText}
//                     onChange={handleChange}
//                     InputProps={{ disableUnderline: true }}
//                   />

//                   {/* <Button type="submit" variant="contained" sx={{ mt: 2 }}>
//                     Post
//                   </Button> */}
//                 </Form>
//               )}
//             </Formik>
//             {/* <input
//               accept="image/*"
//               id="upload-image"
//               type="file"
//               style={{ display: 'none' }}
//               onChange={handleImageUpload}
//             /> */}
//             <input
//               // accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
//               accept='.jpg,.jpeg,.png,.gif,.mp4,.mov,.avi,.mkv,.mp3,.wav,.pdf,.doc,.docx'
//               id="upload-image"
//               type="file"
//               style={{ display: 'none' }}
//               onChange={handleImageUpload}
//               multiple

//             // onChange={handleFileUpload}
//             />

//             <label htmlFor="upload-image">
//               <IconButton component="span">
//                 <ImageIcon />
//               </IconButton>
//             </label>
//           </Box>
//           {/* 
//           {imagePreview && (
//             <Box mt={2}>
//               <img src={imagePreview} alt="Preview" width="100%" style={{ borderRadius: 8, maxHeight: 450 }} />
//             </Box>
//           )} */}

//           {/* {imagePreview && (
//             <Box mt={2}>
//               {imagePreview.type?.startsWith('image/') && (
//                 <img
//                   src={URL.createObjectURL(imagePreview)}
//                   alt="Preview"
//                   width="100%"
//                   style={{ borderRadius: 8, maxHeight: 450 }}
//                 />
//               )}

//               {imagePreview.type?.startsWith('video/') && (
//                 <video
//                   controls
//                   width="100%"
//                   style={{ borderRadius: 8, maxHeight: 450 }}
//                 >
//                   <source src={URL.createObjectURL(imagePreview)} type={imagePreview.type} />
//                   Your browser does not support the video tag.
//                 </video>
//               )}

//               {imagePreview.type === 'application/pdf' && (
//                 <iframe
//                   src={URL.createObjectURL(imagePreview)}
//                   width="100%"
//                   height="450"
//                   style={{ borderRadius: 8 }}
//                   title="PDF Preview"
//                 />
//               )}

//               {[
//                 'application/msword',
//                 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
//                 'application/vnd.ms-excel',
//                 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//                 'application/vnd.ms-powerpoint',
//                 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
//                 'text/plain',
//               ].includes(imagePreview.type) && (
//                   <Box p={2} border="1px solid #ccc" borderRadius={2}>
//                     <Typography>
//                       Selected File: <strong>{imagePreview.name}</strong>
//                     </Typography>
//                   </Box>
//                 )}
//             </Box>
//           )} */}

//           {uploadedFiles.length > 0 && (
//             <>
//               {uploadedFiles?.length === 1 ? (

//                 <Box p={1} key={uploadedFiles[0]?.name}>
//                   {uploadedFiles[0]?.type.startsWith('image/') && (
//                     <img
//                       src={URL.createObjectURL(uploadedFiles[0])}
//                       // alt={`preview-${index}`}
//                       width="100%"
//                       style={{ borderRadius: 8, maxHeight: 450 }}
//                     />
//                   )}

//                   {uploadedFiles[0]?.type.startsWith('video/') && (
//                     <video controls width="100%" style={{ borderRadius: 8, maxHeight: 450 }}>
//                       <source src={URL.createObjectURL(uploadedFiles[0])} type={uploadedFiles[0]?.type} />
//                       Your browser does not support the video tag.
//                     </video>
//                   )}

//                   {uploadedFiles[0]?.type === 'application/pdf' && (
//                     <iframe
//                       src={URL.createObjectURL(uploadedFiles[0])}
//                       width="100%"
//                       style={{ borderRadius: 8, height: 450 }}
//                     // title={`PDF Preview ${index}`}
//                     />
//                   )}

//                   {[
//                     'application/msword',
//                     'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
//                     'application/vnd.ms-excel',
//                     'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//                     'application/vnd.ms-powerpoint',
//                     'application/vnd.openxmlformats-officedocument.presentationml.presentation',
//                     'text/plain',
//                   ].includes(uploadedFiles[0]?.type) && (
//                       <Box p={2} border="1px solid #ccc" borderRadius={2}>
//                         <Typography>
//                           Selected File: <strong>{uploadedFiles[0]?.name}</strong>
//                         </Typography>
//                       </Box>
//                     )}
//                 </Box>
//               ) : (

//                 <Box mt={2}>
//                   <Slider {...settings}>
//                     {uploadedFiles.map((file, index) => (
//                       <Box p={1} key={file.name}>
//                         {file.type.startsWith("image/") && (
//                           <img
//                             src={URL.createObjectURL(file)}
//                             alt={`preview-${index}`}
//                             width="100%"
//                             style={{ borderRadius: 8, maxHeight: 450 }}
//                           />
//                         )}

//                         {file.type.startsWith("video/") && (
//                           <>
//                             <h1>vallla</h1>
//                             <video controls width="100%" style={{ borderRadius: 8, maxHeight: 450 }}>
//                               <source src={URL.createObjectURL(file)} type={file.type} />
//                               Your browser does not support the video tag.
//                             </video>
//                           </>
//                         )}

//                         {file.type === "application/pdf" && (
//                           <iframe
//                             src={URL.createObjectURL(file)}
//                             width="100%"

//                             style={{ borderRadius: 8, height: 450 }}
//                             title={`PDF Preview ${index}`}
//                           />
//                         )}

//                         {[
//                           "application/msword",
//                           "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
//                           "application/vnd.ms-excel",
//                           "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//                           "application/vnd.ms-powerpoint",
//                           "application/vnd.openxmlformats-officedocument.presentationml.presentation",
//                           "text/plain",
//                         ].includes(file.type) && (
//                             <Box p={2} border="1px solid #ccc" borderRadius={2}>
//                               <Typography>
//                                 Selected File: <strong>{file.name}</strong>
//                               </Typography>
//                             </Box>
//                           )}
//                       </Box>
//                     ))}
//                   </Slider>
//                 </Box>
//               )}
//             </>
//           )}



//           <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
//             <Button
//               variant="contained"
//               color="primary"
//               onClick={handlePost}
//               disabled={!postText && !imagePreview}
//             >
//               Post
//             </Button>
//           </Box>
//         </CardContent>
//       </Card>

//       {/* Render Submitted Posts */}
//       {postsForUser.map((post) => (
//         <Card key={post.id} sx={{ mt: 2, borderRadius: 2 }}>
//           <CardContent>
//             <Box display="flex" alignItems="center" gap={1} mb={1}>
//               <Avatar src={profile_image}
//                 sx={{
//                   border: "1px solid gray",
//                   "& .MuiAvatar-img": {
//                     objectFit: "contain"
//                   }
//                 }} />
//               <Typography fontWeight={600}>John Doe</Typography>
//             </Box>
//             <Divider />


//             <Typography sx={{ mt: 1 }}>{post.text}</Typography>

//             {/* {post?.image?.images?.length > 0 && (
//               <Box mt={1}>
//                 <Slider {...settings}>
//                   {post.image.images.map((data, index) => (
//                     <Box key={index}>
//                       <img
//                         src={data.url_path}
//                         alt={`Post ${index + 1}`}
//                         width="100%"
//                         style={{ borderRadius: 8, maxHeight: 450, objectFit: "cover" }}
//                       />
//                     </Box>
//                   ))}
//                   {post.image.videos.map((data, index) => (
//                     <Box key={index}>
//                       <videos
//                         src={data.url_path}
//                         alt={`Post ${index + 1}`}
//                         width="100%"
//                         style={{ borderRadius: 8, maxHeight: 450, objectFit: "cover" }}
//                       />
//                     </Box>
//                   ))}
//                   {post.image.documents.map((data, index) => (
//                     <Box key={index}>
//                       <iframe
//                         src={data.url_path}
//                         alt={`Post ${index + 1}`}
//                         width="100%"
//                         style={{ borderRadius: 8, maxHeight: 450, objectFit: "cover" }}
//                       />
//                     </Box>
//                   ))}
//                 </Slider>
//               </Box>
//             )} */}

//             {(post?.image?.images?.length > 0 ||
//               post?.image?.videos?.length > 0 ||
//               post?.image?.documents?.length > 0) && (

//                 <>
//                   {((post?.image?.images?.length + post?.image?.videos?.length + post?.image?.documents?.length) === 1) ? (

//                     <Box p={1}>
//                       {post?.image?.images?.length === 1 && (
//                         <img
//                           src={post?.image?.images[0]?.url_path}
//                           // alt={`preview-${index}`}
//                           width="100%"
//                           style={{ borderRadius: 8, maxHeight: 450 }}
//                         />
//                       )}

//                       {post?.image?.videos?.length === 1 && (
//                         <video controls width="100%" style={{ borderRadius: 8, maxHeight: 450 }}>
//                           <source
//                             // src={URL.createObjectURL(uploadedFiles[0])} type={uploadedFiles[0]?.type}
//                             src={post?.image?.videos[0]?.url_path}

//                           />
//                           Your browser does not support the video tag.
//                         </video>
//                       )}

//                       {post?.image?.documents?.length === 1 && (
//                         <iframe
//                           // src={URL.createObjectURL(uploadedFiles[0])}
//                           src={post?.image?.documents[0]?.url_path}

//                           width="100%"
//                           style={{ borderRadius: 8, height: 450 }}
//                         // title={`PDF Preview ${index}`}
//                         />
//                       )}

//                       {/* {[
//                         'application/msword',
//                         'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
//                         'application/vnd.ms-excel',
//                         'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//                         'application/vnd.ms-powerpoint',
//                         'application/vnd.openxmlformats-officedocument.presentationml.presentation',
//                         'text/plain',
//                       ].includes(uploadedFiles[0]?.type) && (
//                           <Box p={2} border="1px solid #ccc" borderRadius={2}>
//                             <Typography>
//                               Selected File: <strong>{uploadedFiles[0]?.name}</strong>
//                             </Typography>
//                           </Box>
//                         )} */}
//                     </Box>
//                   ) : (

//                     <Box mt={1}>
//                       <Slider {...settings}>
//                         {post?.image?.images?.map((data, index) => (
//                           <Box key={`img-${index}`}>
//                             <img
//                               src={data.url_path}
//                               alt={`Post image ${index + 1}`}
//                               width="100%"
//                               style={{ borderRadius: 8, maxHeight: 450, objectFit: "cover" }}
//                             />
//                           </Box>
//                         ))}
//                         {post?.image?.videos?.map((data, index) => (
//                           <Box key={`video-${index}`}>
//                             <video
//                               src={data.url_path}
//                               controls
//                               width="100%"
//                               style={{ borderRadius: 8, maxHeight: 450, objectFit: "cover" }}
//                             />
//                           </Box>
//                         ))}
//                         {post?.image?.documents?.map((data, index) => (
//                           <Box key={`doc-${index}`}>
//                             <iframe
//                               src={data?.url_path}
//                               width="100%"
//                               height="450"
//                               style={{ borderRadius: 8 }}
//                             />
//                           </Box>
//                         ))}
//                       </Slider>
//                     </Box>
//                   )}
//                 </>
//               )}

//             {/* {post.image && (
//               <Box mt={1}>
//                 <img src={post.image} alt="Post" width="100%" style={{ borderRadius: 8, maxHeight: 450 }} />
//               </Box>
//             )} */}
//             <Box mt={2} display="flex" gap={2} alignItems="center">
//               {/* <IconButton sx={{ fontSize: "16px" }} onClick={() => handleLike(post.id)}>
//                 <VscHeart style={{ fontSize: "20px" }} />&nbsp;
//                 <Typography variant="body2">{post.likes} Like</Typography>
//               </IconButton> */}
//               {/* <Box key={post.id} mt={2} display="flex" gap={2} alignItems="center"> */}
//               <IconButton
//                 sx={{ fontSize: "16px", color: "inherit" }}
//                 onClick={() => handleLike(post.id)}
//               >
//                 {likedPosts.includes(post.id) ? (
//                   <FaHeart style={{ fontSize: "20px", color: "red" }} />
//                 ) : (
//                   <VscHeart style={{ fontSize: "20px" }} />
//                 )}
//                 &nbsp;
//                 <Typography variant="body1" sx={{ fontSize: "16px", fontWeight: "500 !important", color: "black" }}>{post.likes} Like</Typography>
//               </IconButton>
//               {/* </Box> */}
//               <IconButton sx={{ fontSize: "16px" }} onClick={() => toggleCommentBox(post.id)}>
//                 <ChatBubbleOutlineOutlinedIcon style={{ fontSize: "20px" }} />&nbsp;
//                 <Typography variant="body1" sx={{ fontSize: "16px", fontWeight: "500 !important", color: "black" }}>{post.comments.length} Comment </Typography>
//               </IconButton>
//             </Box>

//             {/* {post.showCommentBox && (
//               <Box mt={2}>
//                 <TextField
//                   variant="outlined"
//                   size="small"
//                   fullWidth
//                   placeholder="Write a comment..."
//                   onKeyDown={(e) => {
//                     if (e.key === 'Enter' && e.target.value.trim() !== '') {
//                       handleAddComment(post.id, e.target.value.trim());
//                       e.target.value = '';
//                     }
//                   }}
//                 />
//                 {post?.comments?.length > 0 && (
//                   <Box mt={1}>
//                     {post.comments.map((cmt, i) => (
//                       <Typography key={i} variant="body2" sx={{ mt: 0.5, ml: 1 }}>• {cmt}</Typography>
//                     ))}
//                   </Box>
//                 )}
//               </Box>
//             )} */}
//             {post.showCommentBox && (
//               <Box mt={2}>
//                 {/* Main comment input */}
//                 <TextField
//                   variant="outlined"
//                   size="small"
//                   fullWidth
//                   placeholder="Write a comment..."
//                   onKeyDown={(e) => {
//                     if (e.key === 'Enter' && e.target.value.trim() !== '') {
//                       handleAddComment(post.id, e.target.value.trim());
//                       e.target.value = '';
//                     }
//                   }}
//                 />

//                 {/* Display comments */}
//                 {post.comments.length > 0 && (
//                   <Box mt={2}>
//                     {post.comments.map((comment, idx) => (
//                       <Box key={idx} ml={1} mt={1}>
//                         <Box>
//                           <Box display="flex" alignItems="center" gap={1} mb={1}>
//                             <Avatar src={comment.profile_image}
//                               sx={{
//                                 border: "1px solid gray",
//                                 "& .MuiAvatar-img": {
//                                   objectFit: "contain"
//                                 }
//                               }} />
//                             <Box>
//                               <Typography variant='subtitle2' color="black">John Doe</Typography>
//                               <Typography variant="body1">{comment.text}</Typography>
//                             </Box>
//                           </Box>

//                           {/* Reply clickable text */}
//                           <Typography
//                             variant="body1"
//                             sx={{ color: 'primary.main', cursor: 'pointer', ml: 6 }}
//                             onClick={() => setReplyingToIndex(idx)}
//                           >
//                             Reply
//                           </Typography>
//                         </Box>

//                         {/* Replies */}
//                         {comment.replies.length > 0 && (
//                           <Box ml={3} mt={1}>
//                             {comment.replies.map((reply, rIdx) => (
//                               <Box display="flex" alignItems="center" gap={1} mb={1}>
//                                 <Avatar src={profile_image}
//                                   sx={{
//                                     border: "1px solid gray",
//                                     "& .MuiAvatar-img": {
//                                       objectFit: "contain"
//                                     }
//                                   }} />
//                                 <Box>
//                                   <Typography variant='subtitle2' color="black">John Doe</Typography>
//                                   <Typography variant="body1">{reply}</Typography>
//                                 </Box>
//                               </Box>
//                             ))}
//                           </Box>
//                         )}

//                         {/* Show reply input if replyingToIndex === current comment index */}
//                         {replyingToIndex === idx && (
//                           <TextField
//                             variant="outlined"
//                             size="small"
//                             placeholder="Reply..."
//                             fullWidth
//                             sx={{ mt: 1 }}
//                             autoFocus
//                             onKeyDown={(e) => {
//                               if (e.key === 'Enter' && e.target.value.trim() !== '') {
//                                 handleAddComment(post.id, e.target.value.trim(), idx);
//                                 e.target.value = '';
//                                 setReplyingToIndex(null); // hide input after replying
//                               }
//                             }}
//                           />
//                         )}
//                       </Box>
//                     ))}
//                   </Box>
//                 )}
//               </Box>
//             )}


//           </CardContent>
//         </Card>
//       ))}
//     </Box>
//   );
// };

// export default PostBox;



// // import React, { useState } from 'react';
// // import {
// //   Card, CardContent, TextField, Button, IconButton, Avatar, Box, Typography
// // } from '@mui/material';
// // import ImageIcon from '@mui/icons-material/Image';
// // import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
// // import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';

// // const PostBox = () => {
// //   const [postText, setPostText] = useState('');
// //   const [imagePreview, setImagePreview] = useState(null);

// //   const handleImageUpload = (e) => {
// //     const file = e.target.files[0];
// //     if (file) {
// //       setImagePreview(URL.createObjectURL(file));
// //     }
// //   };

// //   const handlePost = () => {
// //     console.log('Post:', postText);
// //     console.log('Image:', imagePreview);
// //     setPostText('');
// //     setImagePreview(null);
// //   };

// //   return (
// //     <Card sx={{ maxWidth: 500, margin: 'auto', mt: 2, borderRadius: 2 }}>
// //       <CardContent>
// //         <Typography variant="h6" gutterBottom>Post Something</Typography>
// //         <Box display="flex" alignItems="center" gap={1}>
// //           <Avatar src="https://randomuser.me/api/portraits/men/11.jpg" />
// //           <TextField
// //             fullWidth
// //             placeholder="What's on your mind?"
// //             variant="standard"
// //             value={postText}
// //             onChange={(e) => setPostText(e.target.value)}
// //             InputProps={{ disableUnderline: true }}
// //           />
// //           <input
// //             accept="image/*"
// //             id="upload-image"
// //             type="file"
// //             style={{ display: 'none' }}
// //             onChange={handleImageUpload}
// //           />
// //           <label htmlFor="upload-image">
// //             <IconButton component="span">
// //               <ImageIcon />
// //             </IconButton>
// //           </label>
// //         </Box>

// //         {imagePreview && (
// //           <Box mt={2}>
// //             <img src={imagePreview} alt="Preview" width="100%" style={{ borderRadius: 8 }} />
// //           </Box>
// //         )}

// //         <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
// //           <Button variant="contained" color="primary" onClick={handlePost}>Post</Button>
// //           <Box>
// //             <IconButton><ThumbUpAltOutlinedIcon /></IconButton>
// //             <IconButton><ChatBubbleOutlineOutlinedIcon /></IconButton>
// //           </Box>
// //         </Box>
// //       </CardContent>
// //     </Card>
// //   );
// // };

// // export default PostBox;


// import React, { useState } from 'react';
// import {
//   Card, CardContent, TextField, Button, IconButton, Avatar, Box, Typography,
//   Divider
// } from '@mui/material';
// import ImageIcon from '@mui/icons-material/Image';
// import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
// import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
// import profile_image from "../../Assets/Media.jpg"
// import { TbHeartFilled } from "react-icons/tb";
// import { VscHeart } from "react-icons/vsc";



// const PostBox = () => {
//   const [postText, setPostText] = useState('');
//   const [imagePreview, setImagePreview] = useState(null);
//   const [posts, setPosts] = useState([]);

//   const handleImageUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setImagePreview(URL.createObjectURL(file));
//     }
//   };

//   const handlePost = () => {
//     const newPost = {
//       id: Date.now(),
//       text: postText,
//       image: imagePreview,
//     };
//     setPosts([newPost, ...posts]); // Add new post at the top
//     setPostText('');
//     setImagePreview(null);
//   };

//   return (
//     <Box sx={{
//       // maxWidth: 550,
//       margin: 'auto',
//       mt: 2,
//       boxShadow: 4
//     }}>

//       {/* Input Box */}
//       <Card sx={{ borderRadius: 2 }}>
//         <CardContent>
//           <Typography variant="h6" gutterBottom>Post Something</Typography>
//           <Divider />
//           <Box display="flex" alignItems="center" gap={1} mt={1}>
//             <Avatar src={profile_image}
//               sx={{
//                 border: "1px solid gray",
//                 "& .MuiAvatar-img": {
//                   objectFit: "contain"
//                 }
//               }} />
//             <TextField
//               sx={{ border: "1px solid #f4f2ee", p: 1 }}
//               fullWidth
//               placeholder="What's on your mind?"
//               variant="standard"
//               value={postText}
//               onChange={(e) => setPostText(e.target.value)}
//               InputProps={{ disableUnderline: true }}
//             />
//             <input
//               accept="image/*"
//               id="upload-image"
//               type="file"
//               style={{ display: 'none' }}
//               onChange={handleImageUpload}
//             />
//             <label htmlFor="upload-image">
//               <IconButton component="span">
//                 <ImageIcon />
//               </IconButton>
//             </label>
//           </Box>

//           {imagePreview && (
//             <Box mt={2}>
//               <img src={imagePreview} alt="Preview" width="100%" style={{ borderRadius: 8 }} />
//             </Box>
//           )}

//           <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
//             <Button
//               variant="contained"
//               color="primary"
//               onClick={handlePost}
//               disabled={!postText && !imagePreview}
//             >
//               Post
//             </Button>
//             {/* <Box>
//               <IconButton><ThumbUpAltOutlinedIcon /></IconButton>
//               <IconButton><ChatBubbleOutlineOutlinedIcon /></IconButton>
//             </Box> */}
//           </Box>
//         </CardContent>
//       </Card>

//       {/* Render Submitted Posts */}
//       {posts.map((post) => (
//         <Card key={post.id} sx={{ mt: 2, borderRadius: 2 }}>
//           <CardContent>
//             <Box display="flex" alignItems="center" gap={1} mb={1}>
//               {/* <Avatar src="https://randomuser.me/api/portraits/men/11.jpg" /> */}
//               <Avatar src={profile_image}
//                 sx={{
//                   border: "1px solid gray",
//                   "& .MuiAvatar-img": {
//                     objectFit: "contain"
//                   }
//                 }} />
//               <Typography fontWeight={600}>John Doe</Typography>
//             </Box>
//             <Divider />

//             <Typography>{post.text}</Typography>
//             {post.image && (
//               <Box mt={1}>
//                 <img src={post.image} alt="Post" width="100%" style={{ borderRadius: 8 }} />
//               </Box>
//             )}
//             <Box mt={2} display="flex" gap={1}>
//               <IconButton sx={{fontSize:"16px"}}><VscHeart style={{fontSize:"20px"}}/> Like</IconButton>
//               <IconButton sx={{fontSize:"16px"}}><ChatBubbleOutlineOutlinedIcon style={{fontSize:"20px"}}/> Comment</IconButton>
//             </Box>
//           </CardContent>
//         </Card>
//       ))}
//     </Box>
//   );
// };

// export default PostBox;




import React, { useEffect, useState } from 'react';
import {
  Card, CardContent, TextField, Button, IconButton, Avatar, Box, Typography,
  Divider
} from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import profile_image from "../../../Assets/Media.jpg"
import { VscHeart } from "react-icons/vsc";
import { FaHeart } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../ReduxStore/actions';
import { toast, ToastContainer } from 'react-toastify';
import FullPageLoader from '../../../Components/FullPageLoader/FullPageLoader';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Form, Formik } from 'formik';
import CustomInputLogin from '../../../Components/CustomInputLogin/CustomInputLogin';
import { adminUrl } from '../../../constants';
import EmojiPickerComponent from '../../../Components/EmojiPickerComponent/EmojiPickerComponent';
import CustomInputWithEmoji from '../../../Components/CustomInputLogin/CustomInputWithEmoji';
import PostJobViewModal from '../PostJobs/PostJob/PostJobViewModal';
import PostInternshipViewModal from '../PostJobs/PostInternship/PostInternshipViewModal';
import { commentOnFeedAction } from '../../../ReduxStore/Slices/Post/commentOnFeed';
import CustomCommentInputWithEmoji from '../../../Components/CustomInputLogin/CustomCommentInputWithEmoji';



const PostBox = () => {
  const [postText, setPostText] = useState('');
  const [imagePreview, setImagePreview] = useState(null);
  const [posts, setPosts] = useState([]);

  console.log(posts, "postsssssssssssss")
  const [replyingToIndex, setReplyingToIndex] = useState(null);
  console.log(postText, "postText")
  console.log(imagePreview, "postText 1")

  const { getUserById } = useSelector(state => state?.getUserById);


  const { MyPostForusers } = useSelector(state => state?.MyPostForusers);
  const { MyPostForUsersGetAll } = useSelector(state => state?.MyPostForUsersGetAll);
  console.log(MyPostForusers, "postsForUserpostsForUser 22")

  console.log(MyPostForUsersGetAll, "postsForUserpostsForUser 11")

  const [uploadedFiles, setUploadedFiles] = useState([])
  console.log(uploadedFiles, 'uploadedFiless')
  console.log(uploadedFiles?.length, 'uploadedFiles couunt')
  console.log(uploadedFiles[0]?.type, 'uploadedFiles type')




  // user id get rom sesstion storage
  const sessionUserId = sessionStorage.getItem("userId")
  console.log(sessionUserId, "sessionUserId")

  const [selectedFiles, setSelectedFiles] = useState([])

  const handleImageUpload = async (e) => {
    const files = Array.from(e.target.files); // All selected files

    if (files.length === 0) return;

    const updatedFiles = [...selectedFiles, ...files];
    setSelectedFiles(updatedFiles);

    const formData = new FormData();

    updatedFiles.forEach((file) => {
      formData.append("uploadFiles", file); // same key used multiple times
    });

    const data1 = {
      data: formData,
      method: "post",
      apiName: "multiplefiles",
    };

    try {
      const response = await dispatch(actions.UPLOADPDFILEPOST(data1));
      console.log(response, "uploadPdfAndImageResponse");
      setUploadedFiles(response?.payload?.data?.files);
    } catch (error) {
      console.error("Upload failed:", error);
    }
  };


  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false);

  const alumni_user_id = sessionStorage.getItem("alumni_user_id")
  const blobUrlToFile = async (blobUrl, fileName) => {
    const response = await fetch(blobUrl);
    const blob = await response.blob();
    return new File([blob], fileName, { type: blob.type });
  };



  // useEffect(() => {
  //   // const tempArr = [];
  //   const fetchData = async () => {
  //     const data1 = {
  //       data: {},
  //       method: "get",
  //       apiName: `mypost/${alumni_user_id}`,
  //     };
  //     dispatch(actions.MYPOSTFORUSERGETALL(data1));

  //   }
  //   fetchData()
  // }, [MyPostForusers]);


  const { createFeed } = useSelector(
    (state) => state?.createFeed
  );

  const { likeFeed } = useSelector(
    (state) => state?.likeFeed
  );

  const { unlikeFeed } = useSelector(
    (state) => state?.unlikeFeed
  );

  const { getCommentsWithReplies } = useSelector(
    (state) => state?.getCommentsWithReplies
  );

  const { getFeedLikedUsers } = useSelector(
    (state) => state?.getFeedLikedUsers
  );

  console.log(getFeedLikedUsers, "getFeedLikedUsers")



  const { getUserAndConnectionsFeedsWithLikeWithComment } = useSelector(
    (state) => state?.getUserAndConnectionsFeedsWithLikeWithComment
  );

  const handlePost = async (values) => {
    console.log(values, "valuessssss")

    console.log(uploadedFiles, "uploadedFilesssssss")
    const data1 = {
      data: {
        // text:"4343434"
        user_id: sessionUserId,
        content: { text: values?.postText },
        media: uploadedFiles

      },
      method: "post",
      apiName: `createFeed`,
      // isFormData: true,
    };

    const responseData = await dispatch(actions.CREATEFEED(data1));
    console.log(responseData, "responseData")
    console.log(responseData, "responseDtata")
    if (responseData?.payload?.message === "Feed posted successfully.") {
      setLoading(false);
      console.log("itswork")
      // resetForm()
      // resetForm();
      // setUploadedFile([]); // Assuming this manages UI state
      // handleAddFormGoBackButton();
      // setTimeout(() => {
      toast.success(`Post added successfully.`)
      setSelectedFiles([])
      setUploadedFiles([]);

      // }, 1500);
    } else {
      setLoading(false);
      toast.error(responseData?.payload?.message);
    }


    const newPost = {
      id: Date.now(),
      text: postText,
      image: imagePreview,
      likes: 0,
      comments: [],
      showCommentBox: false,
    };
    setPosts([newPost, ...posts]); // Add new post at the top
    setPostText('');
    setImagePreview(null);
  };



  const { commentOnFeed } = useSelector(
    (state) => state?.commentOnFeed
  );


  const { replyToComment } = useSelector(
    (state) => state?.replyToComment
  );


  //get all post api integration

  useEffect(() => {

    const fetchData = async () => {
      const data1 = {
        data: {},
        method: "get",
        apiName: `getUserAndConnectionsFeedsWithLikeWithComment/${sessionUserId}`,
      };
      const response = await dispatch(actions.GETUSERANDCONNECTIONSFEEDSWITHLIKEWITHCOMMENT(data1));

      console.log(response, "responseresponse")

      if (response?.payload?.message === "User and connection feeds fetched successfully.") {
        const allPostData = response?.payload?.data?.map((data) => ({
          id: data?.feed_id,
          user_id: data?.user_id,
          text: data?.content?.text,
          feed_type: data?.content?.feed_type,
          type_id: data?.content?.type_id,

          media: data?.media,
          postUserData: data?.user,
          likeCount: data?.likeCount,
          commentCount: data?.commentCount,
          isLiked: data?.isLiked,


          showCommentBox: false,
          showLikeBox: false


        }))
        setPosts(allPostData)

      }
    }
    fetchData()


  }, [createFeed, likeFeed, unlikeFeed, commentOnFeed, replyToComment])


  const settings = {
    dots: true,
    // infinite: true,
    speed: 500,
    height: 450,
    slidesToShow: 1,
    slidesToScroll: 1
  };



  // const handleLike = (postId) => {
  //   setPosts(posts.map(post =>
  //     post.id === postId ? { ...post, likes: post.likes + 1 } : post
  //   ));
  // };


  // const [posts, setPosts] = useState([
  //   { id: 1, likes: 0 },
  //   { id: 2, likes: 5 },
  //   // ...other posts
  // ]);
  const [likedPosts, setLikedPosts] = useState([]); // track liked post IDs


  const handleLikePost = async (feed_id, isLiked) => {
    // console.log(id, "idddddddddd")
    if (!isLiked) {
      const data1 = {
        data: {
          user_id: sessionUserId
        },
        method: "post",
        apiName: `likeFeed/${feed_id}`,
      };
      const response = await dispatch(actions.LIKEFEED(data1));
      console.log(response, "responsedataaaaaaa")
    } else {
      const data1 = {
        data: {
          user_id: sessionUserId
        },
        method: "delete",
        apiName: `unlikeFeed/${feed_id}`,
      };
      const response = await dispatch(actions.UNLIKEFEED(data1));
      console.log(response, "responsedataaaaaaa")

    }
  }

  const handleLike = (postId) => {
    if (!likedPosts.includes(postId)) {
      setPosts(posts.map(post =>
        post.id === postId ? { ...post, likes: post.likes + 1 } : post
      ));
      setLikedPosts([...likedPosts, postId]); // add to liked posts
    }
  };

  // show comments
  const [isShowCommment, setShowcomment] = useState(false)
  const handleGetCommentsDetails = async (feed_id) => {
    const data1 = {
      data: {},
      method: "get",
      apiName: `getCommentsWithReplies/${feed_id}`,
    };
    const response = await dispatch(actions.GETCOMMENTSWITHREPLIES(data1));
    console.log(response, "responsedataaaaaaa")
  }

  const handleGetLikeDetails = async (feed_id) => {
    const data1 = {
      data: {},
      method: "get",
      apiName: `getFeedLikedUsers/${feed_id}`,
    };
    const response = await dispatch(actions.GETFEEDLIKEDUSERS(data1));
    console.log(response, "responsedataaaaaaa")
  }


  // const toggleCommentBox = (feed_id) => {
  //   setShowcomment(!isShowCommment)


  //   if (!isShowCommment) {
  //     handleGetCommentsDetails(feed_id)

  //     // setPosts(posts.map(post =>
  //     //   post.id === postId ? { ...post, showCommentBox: !post.showCommentBox } : post
  //     // ));
  //   };
  // }


  // const toggleCommentBox = (feed_id) => {
  //   setPosts((prevPosts) =>
  //     prevPosts.map((post) => {
  //       if (post.id === feed_id) {
  //         if (!post.showCommentBox) {
  //           handleGetCommentsDetails(feed_id);
  //         }
  //         return {
  //           ...post,
  //           showCommentBox: !post.showCommentBox,
  //         };
  //       }
  //       return post;
  //     })
  //   );
  // };


  const toggleLikeBox = (feed_id) => {
    console.log(feed_id, "feed_idfeed_idfeed_idfeed_id")
    const updatedPosts = posts.map((post) => {
      if (post.id === feed_id) {
        if (!post.showLikeBox) {
          handleGetLikeDetails(feed_id); // fetch comments only when opening
        }
        return { ...post, showLikeBox: !post.showLikeBox };
      } else {
        return { ...post, showLikeBox: false }; // close all other comment boxes
      }
    });

    setPosts(updatedPosts);
  };


  const toggleCommentBox = (feed_id) => {
    const updatedPosts = posts.map((post) => {
      if (post.id === feed_id) {
        if (!post.showCommentBox) {
          handleGetCommentsDetails(feed_id); // fetch comments only when opening
        }
        return { ...post, showCommentBox: !post.showCommentBox };
      } else {
        return { ...post, showCommentBox: false }; // close all other comment boxes
      }
    });

    setPosts(updatedPosts);
  };
  // const handleAddComment = (postId, commentText) => {
  //   setPosts(posts.map(post =>
  //     post.id === postId
  //       ? { ...post, comments: [...post.comments, commentText] }
  //       : post
  //   ));
  // };

  const handleAddComment = async (feed_id, commentText, parentIndex = null) => {
    const data1 = {
      data: {
        user_id: sessionUserId,
        content: commentText

      },

      method: "post",
      apiName: `commentOnFeed/${feed_id}`,
    };
    const response = await dispatch(actions.COMMENTONFEED(data1));
    console.log(response, "responsedataaaaaaa")
    if (response?.payload?.message === "Comment posted.") {
      handleGetCommentsDetails(feed_id)

    }



    // setPosts(posts.map(post => {
    //   if (post.id !== postId) return post;

    //   if (parentIndex === null) {
    //     // Add new top-level comment
    //     return {
    //       ...post,
    //       comments: [...post.comments, { text: commentText, profile_image: profile_image, replies: [] }]
    //     };
    //   } else {
    //     // Add reply to existing comment
    //     const updatedComments = [...post.comments];
    //     updatedComments[parentIndex].replies.push(commentText);
    //     return {
    //       ...post,
    //       comments: updatedComments
    //     };
    //   }
    // }));
  };

  const handleReplyComment = async (feed_id, comment_id, commentText, parentIndex = null) => {
    const data1 = {
      data: {
        user_id: sessionUserId,
        content: commentText

      },

      method: "post",

      apiName: `feeds/${feed_id}/comment/${comment_id}/reply`,
    };
    const response = await dispatch(actions.REPLYTOCOMMENT(data1));
    console.log(response, "responsedataaaaaaa")
    if (response?.payload?.message === "Reply posted.") {
      handleGetCommentsDetails(feed_id)

    }
  }


  // const images = post?.image?.images || [];
  // const videos = post?.image?.videos || [];
  // const documents = post?.image?.documents || [];

  // const totalMediaCount = images.length + videos.length + documents.length;
  const [visibleReplies, setVisibleReplies] = useState([]);


  const toggleReplies = (idx) => {
    setVisibleReplies((prev) =>
      prev.includes(idx)
        ? prev.filter((i) => i !== idx) // hide replies
        : [...prev, idx] // show replies
    );
  };

  const [viewJobModalOpen, setViewJobModalOpen] = useState(false)
  const handleViewJobModalOpen = () => {
    setViewJobModalOpen(true)
  }
  const handleViewJobModalClose = () => {
    setViewJobModalOpen(false)
  }



  const [viewInternshipModalOpen, setViewInternshipModalOpen] = useState(false)
  const handleViewInternshipModalOpen = () => {
    setViewInternshipModalOpen(true)
  }
  const handleViewInternshipModalClose = () => {
    setViewInternshipModalOpen(false)
  }



  const handleJobViewDetails = async (id, feed_type) => {
    if (feed_type === "jobpost") {

      const data1 = {
        data: {},
        method: "get",
        apiName: `getJobById/${id}`,
      };
      const response = await dispatch(actions.GETJOBBYID(data1));
      handleViewJobModalOpen()
    } else if (feed_type === "internshippost") {

      const data1 = {
        data: {},
        method: "get",
        apiName: `getInternshipById/${id}`,
      };
      const response = await dispatch(actions.GETINTERNSHIPBYID(data1));
      handleViewInternshipModalOpen()
    }

  }


  return (
    <Box sx={{ margin: 'auto', mt: 2, boxShadow: 4 }}>
      {/* <EmojiPickerComponent /> */}
      {/* Input Box */}
      {loading && <FullPageLoader />}


      <Card sx={{ borderRadius: 2 }}>
        <Formik
          initialValues={{ postText: '' }}
          onSubmit={(values, { resetForm }) => {
            handlePost(values);
            resetForm()
          }}
        >
          {({ values, handleChange, handleSubmit, resetForm }) => (
            <Form onSubmit={handleSubmit}>
              <CardContent>
                <Typography variant="h6" gutterBottom>Post Something</Typography>
                <Divider />
                <Box display="flex" alignItems="center" gap={1} mt={1}>
                  <Avatar src={`${adminUrl}${getUserById?.data?.profileImage}`}
                    sx={{
                      border: "1px solid gray",
                      "& .MuiAvatar-img": {
                        objectFit: "contain"
                      }
                    }} />
                  {/* <TextField
              sx={{ border: "1px solid #f4f2ee", p: 1 }}
              fullWidth
              placeholder="What's on your mind?"
              variant="standard"
              value={postText}
              onChange={(e) => setPostText(e.target.value)}
              InputProps={{ disableUnderline: true }}
            /> */}


                  {/* <TextField
                    name="postText"
                    fullWidth
                    placeholder="What's on your mind?"
                    variant="standard"
                    sx={{ border: '1px solid #f4f2ee', p: 1 }}
                    value={values.postText}
                    onChange={handleChange}
                    InputProps={{ disableUnderline: true }}
                  /> */}
                  <CustomInputWithEmoji
                    name="postText"
                  />


                  <input
                    // accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
                    accept='.jpg,.jpeg,.png,.gif,.mp4,.mov,.avi,.mkv,.mp3,.wav,.pdf,.doc,.docx'
                    id="upload-image"
                    type="file"
                    style={{ display: 'none' }}
                    onChange={handleImageUpload}
                    multiple

                  // onChange={handleFileUpload}
                  />

                  <label htmlFor="upload-image">
                    <IconButton component="span">
                      <ImageIcon />
                    </IconButton>
                  </label>
                </Box>


                {uploadedFiles.length > 0 && (
                  <>
                    {uploadedFiles?.length === 1 ? (

                      <Box p={1} key={uploadedFiles[0]?.name}>
                        {uploadedFiles?.map((file) => (
                          file?.fileType === "image" ? (
                            <>
                              <img
                                src={`${adminUrl}${file?.fileUrl}`}
                                alt="Not support"
                                width="100%"
                                style={{ borderRadius: 8, maxHeight: 450 }}
                              />
                            </>
                          ) : file?.fileType === "video" ? (
                            <video controls width="100%" style={{ borderRadius: 8, maxHeight: 450 }}>
                              <source
                                // src={URL.createObjectURL(uploadedFiles[0])} type={uploadedFiles[0]?.type}
                                // src={post?.image?.videos[0]?.url_path}

                                src={`${adminUrl}${file?.fileUrl}`}
                              />
                              Your browser does not support the video tag.
                            </video>

                          ) : file?.fileType === "pdf" ? (
                            <>
                              <iframe
                                // src={post?.image?.documents[0]?.url_path}
                                src={`${adminUrl}${file?.fileUrl}`}

                                width="100%"
                                style={{ borderRadius: 8, height: 450 }}
                              />
                            </>
                          ) : null
                        ))}


                      </Box>
                    ) : (

                      <Box mt={2}>
                        <Slider {...settings}>
                          {/* {uploadedFiles.map((file, index) => (
                            <Box p={1} key={file.name}>
                              {file.type.startsWith("image/") && (
                                <img
                                  src={URL.createObjectURL(file)}
                                  alt={`preview-${index}`}
                                  width="100%"
                                  style={{ borderRadius: 8, maxHeight: 450 }}
                                />
                              )}

                              {file.type.startsWith("video/") && (
                                <>
                                  <h1>vallla</h1>
                                  <video controls width="100%" style={{ borderRadius: 8, maxHeight: 450 }}>
                                    <source src={URL.createObjectURL(file)} type={file.type} />
                                    Your browser does not support the video tag.
                                  </video>
                                </>
                              )}

                              {file.type === "application/pdf" && (
                                <iframe
                                  src={URL.createObjectURL(file)}
                                  width="100%"

                                  style={{ borderRadius: 8, height: 450 }}
                                  title={`PDF Preview ${index}`}
                                />
                              )}

                              {[
                                "application/msword",
                                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                "application/vnd.ms-excel",
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                "application/vnd.ms-powerpoint",
                                "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                                "text/plain",
                              ].includes(file.type) && (
                                  <Box p={2} border="1px solid #ccc" borderRadius={2}>
                                    <Typography>
                                      Selected File: <strong>{file.name}</strong>
                                    </Typography>
                                  </Box>
                                )}
                            </Box>
                          ))} */}
                          {uploadedFiles?.map((file) => (
                            file?.fileType === "image" ? (
                              <>
                                <img
                                  src={`${adminUrl}${file?.fileUrl}`}
                                  alt="Not support"
                                  width="100%"
                                  style={{ borderRadius: 8, maxHeight: 450 }}
                                />
                              </>
                            ) : file?.fileType === "video" ? (
                              <video controls width="100%" style={{ borderRadius: 8, maxHeight: 450 }}>
                                <source
                                  // src={URL.createObjectURL(uploadedFiles[0])} type={uploadedFiles[0]?.type}
                                  // src={post?.image?.videos[0]?.url_path}

                                  src={`${adminUrl}${file?.fileUrl}`}
                                />
                                Your browser does not support the video tag.
                              </video>

                            ) : file?.fileType === "pdf" ? (
                              <>
                                <iframe
                                  // src={post?.image?.documents[0]?.url_path}
                                  src={`${adminUrl}${file?.fileUrl}`}

                                  width="100%"
                                  style={{ borderRadius: 8, height: 450 }}
                                />
                              </>
                            ) : null
                          ))}
                        </Slider>
                      </Box>
                    )}
                  </>
                )}



                <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
                  <Button
                    type='submit'
                    variant="contained"
                    // color="primary"
                    sx={{
                      background: "var(--main-color)",
                      // textTransform:"none"
                    }}
                  // onClick={handlePost}
                  // disabled={!postText && !imagePreview}
                  >
                    Post
                  </Button>
                </Box>
              </CardContent>
            </Form>
          )}
        </Formik>
      </Card>


      {/* Render Submitted Posts */}
      {
        posts?.map((post, index) => (
          <Card key={post.id} sx={{ mt: 2, borderRadius: 2 }}>
            <CardContent>
              <Box display="flex" alignItems="center" gap={1} mb={1}>
                <Avatar src={`${adminUrl}${post?.postUserData?.profileImage}`}
                  sx={{
                    border: "1px solid gray",
                    "& .MuiAvatar-img": {
                      objectFit: "contain"
                    }
                  }} />
                <Typography fontWeight={550} variant='subtitle1'>{post?.postUserData?.first_name} {post?.postUserData?.last_name}</Typography>
              </Box>
              <Divider />


              <Typography variant="body1" sx={{ color: "black", p: "10px 0px" }}>{post?.text}</Typography>
              {post?.feed_type &&
                <Typography variant='body1' sx={{ color: "var(--main-color)", cursor: "pointer" }} onClick={() => {
                  handleJobViewDetails(post?.type_id, post?.feed_type)
                }}>
                  View details
                </Typography>
              }


              {((post?.media?.length === 1) ? (

                <Box p={1} sx={{ border: "1px solid #ded7d7" }}>
                  {post?.media?.map((file) => (
                    file?.fileType === "image" ? (
                      <>
                        <img
                          src={`${adminUrl}${file?.fileUrl}`}
                          alt="Not support"
                          width="100%"
                          style={{ borderRadius: 8, maxHeight: 450 }}
                        />
                      </>
                    ) : file?.fileType === "video" ? (
                      <video controls width="100%" style={{ borderRadius: 8, maxHeight: 450 }}>
                        <source
                          // src={URL.createObjectURL(uploadedFiles[0])} type={uploadedFiles[0]?.type}
                          // src={post?.image?.videos[0]?.url_path}

                          src={`${adminUrl}${file?.fileUrl}`}
                        />
                        Your browser does not support the video tag.
                      </video>

                    ) : file?.fileType === "pdf" ? (
                      <>
                        <iframe
                          // src={post?.image?.documents[0]?.url_path}
                          src={`${adminUrl}${file?.fileUrl}`}

                          width="100%"
                          style={{ borderRadius: 8, height: 450 }}
                        />
                      </>
                    ) : null
                  ))}
                </Box>

              ) : (

                <Box mt={1}>
                  <Slider {...settings}>
                    {post?.media?.map((file) => (
                      file?.fileType === "image" ? (
                        <>
                          <img
                            src={`${adminUrl}${file?.fileUrl}`}
                            alt="Not support"
                            width="100%"
                            style={{ borderRadius: 8, maxHeight: 450 }}
                          />
                        </>
                      ) : file?.fileType === "video" ? (
                        <video controls width="100%" style={{ borderRadius: 8, maxHeight: 450 }}>
                          <source
                            // src={URL.createObjectURL(uploadedFiles[0])} type={uploadedFiles[0]?.type}
                            // src={post?.image?.videos[0]?.url_path}

                            src={`${adminUrl}${file?.fileUrl}`}
                          />
                          Your browser does not support the video tag.
                        </video>

                      ) : file?.fileType === "pdf" ? (
                        <>
                          <iframe
                            // src={post?.image?.documents[0]?.url_path}
                            src={`${adminUrl}${file?.fileUrl}`}

                            width="100%"
                            style={{ borderRadius: 8, height: 450 }}
                          />
                        </>
                      ) : null
                    ))}
                  </Slider>
                </Box>

              ))}



              <Box mt={2} display="flex" gap={2} alignItems="center">
                <Box
                  sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                >


                  <Box
                    onClick={() => handleLikePost(post?.id, post?.isLiked)}

                  >

                    {post?.isLiked ? (
                      <FaHeart style={{ fontSize: "20px", color: "red" }} />
                    ) : (
                      <VscHeart style={{ fontSize: "20px" }} />
                    )}
                  </Box>
                  &nbsp;
                  {/* <IconButton
                    sx={{ fontSize: "16px", color: "inherit" }}
                    // onClick={() => handleLike(post.id)}
                    // onClick={() => handleLikePost(post?.id, post?.isLiked)}



                  > */}
                  <Box onClick={() => {
                    toggleLikeBox(post?.id)
                  }}>
                    <Typography variant="body1" sx={{ fontSize: "16px", fontWeight: "500 !important", color: "black" }}>{post?.likeCount} Like</Typography>
                    {/* </IconButton> */}
                  </Box>
                </Box>
                <IconButton sx={{ fontSize: "16px" }} onClick={() => toggleCommentBox(post?.id)}>
                  <ChatBubbleOutlineOutlinedIcon style={{ fontSize: "20px" }} />&nbsp;
                  <Typography variant="body1" sx={{ fontSize: "16px", fontWeight: "500 !important", color: "black" }}>{post?.commentCount} Comment </Typography>
                </IconButton>
              </Box>
              {post?.showLikeBox && (
                <Box>
                  <Divider />

                  <Typography variant='body1' sx={{ mt: 2, color: "black" }}>All Likes</Typography>

                  {getFeedLikedUsers?.data?.map((likeUser, index) => (
                    <>

                      <Box display="flex" alignItems="center" gap={1} mb="4px" mt="10px" key={index}>
                        <Avatar src={`${adminUrl}${likeUser?.profileImage}`}
                          sx={{
                            border: "1px solid gray",
                            "& .MuiAvatar-img": {
                              objectFit: "contain"
                            }
                          }} />
                        <Box>
                          <Typography variant='subtitle2' color="black" >{likeUser?.first_name} {likeUser?.last_name}</Typography>
                          {/* <Typography variant="body1" sx={{ color: "black" }}>{getFeedLikedUsers?.content}</Typography> */}
                        </Box>
                      </Box>
                    </>
                  ))}
                </Box>
              )}

              {post?.showCommentBox && (
                <Box mt={2}>
                  <Formik
                    initialValues={{ comments: [''] }}
                    onSubmit={(values) => {
                      console.log(values);
                    }}
                  >
                    {({ handleSubmit }) => (
                      <Form onSubmit={handleSubmit}>
                        {/* Main comment input */}

                        <CustomCommentInputWithEmoji
                          name={`comments.${index}`} // If you're managing comments via Formik
                          custPlaceholder="Write a comment..."
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' && e.target.value.trim() !== '') {
                              handleAddComment(post.id, e.target.value, index);
                              e.target.value = '';
                            }
                          }}
                        />

                      </Form>
                    )}
                  </Formik>
                  {/* <TextField
                    key={index}
                    variant="outlined"
                    size="small"
                    fullWidth
                    placeholder="Write a comment..."
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && e.target.value.trim() !== '') {
                        handleAddComment(post.id, e.target.value, index);
                        e.target.value = '';
                      }
                    }}
                  /> */}

                  {/* Display comments */}
                  {getCommentsWithReplies?.data?.length > 0 && (

                    <Box mt={2}>
                      {getCommentsWithReplies?.data?.map((comment, idx) => (
                        <Box key={idx} ml={1} mt={2}>
                          <Box>
                            <Box display="flex" alignItems="center" gap={1} mb="4px">
                              <Avatar src={`${adminUrl}${comment?.User?.profileImage}`}
                                sx={{
                                  border: "1px solid gray",
                                  "& .MuiAvatar-img": {
                                    objectFit: "contain"
                                  }
                                }} />
                              <Box>
                                <Typography variant='subtitle2' color="black" >{comment?.User?.first_name} {comment?.User?.last_name}</Typography>
                                <Typography variant="body1" sx={{ color: "black" }}>{comment?.content}</Typography>
                              </Box>
                            </Box>

                            {/* Reply clickable text */}

                            <Box sx={{ display: "flex", ml: 6 }}>
                              <Typography
                                variant="body1"
                                sx={{ cursor: 'pointer', mr: 2, fontSize: "12px", color: 'var(--main-color)', }}
                                onClick={() => setReplyingToIndex(idx)}
                              >
                                Reply
                              </Typography>

                              {comment?.Replies.length > 0 && (

                                < Typography
                                  variant="body1"
                                  sx={{ color: 'var(--main-color)', cursor: 'pointer', fontSize: "12px" }}
                                  onClick={() => toggleReplies(idx)}
                                >
                                  {visibleReplies.includes(idx) ? 'Hide replies' : 'Show replies'}
                                </Typography>
                              )}

                            </Box>
                          </Box>

                          {/* Replies */}
                          {/* {comment?.Replies.length > 0 && ( */}
                          {
                            visibleReplies.includes(idx) && comment?.Replies.length > 0 && (
                              <Box ml={5} mt={2}>
                                {comment?.Replies?.map((reply, rIdx) => (
                                  <Box display="flex" alignItems="center" gap={1} mb={2}>
                                    <Avatar src={`${adminUrl}${reply?.User?.profileImage}`}
                                      sx={{
                                        border: "1px solid gray",
                                        "& .MuiAvatar-img": {
                                          objectFit: "contain"
                                        }
                                      }} />
                                    <Box>
                                      <Typography variant='subtitle2' color="black">{reply?.User?.first_name} {reply?.User?.last_name}</Typography>
                                      <Typography variant="body1" sx={{ color: "black" }}>{reply?.content}</Typography>
                                    </Box>
                                  </Box>
                                ))}
                              </Box>
                            )
                          }

                          {/* Show reply input if replyingToIndex === current comment index */}
                          {replyingToIndex === idx && (


                            <>
                              <Formik
                                initialValues={{ comments: [''] }}
                                onSubmit={(values) => {
                                  console.log(values);
                                }}
                              >
                                {({ handleSubmit }) => (
                                  <Form onSubmit={handleSubmit}>
                                    {/* Main comment input */}

                                    <CustomCommentInputWithEmoji
                                      name={`comments.${index}`} // If you're managing comments via Formik
                                      custPlaceholder="Write a comment..."
                                      onKeyDown={(e) => {
                                        if (e.key === 'Enter' && e.target.value.trim() !== '') {
                                          // handleAddComment(post.id, e.target.value, index);
                                          handleReplyComment(comment?.feed_id, comment?.comment_id, e.target.value, idx);

                                          e.target.value = '';
                                          setReplyingToIndex(null); // hide input after replying

                                        }
                                      }}
                                    />

                                  </Form>
                                )}
                              </Formik>


                              {/* <TextField
                              variant="outlined"
                              size="small"
                              placeholder="Reply..."
                              fullWidth
                              sx={{ mt: 1 }}
                              autoFocus
                              onKeyDown={(e) => {
                                if (e.key === 'Enter' && e.target.value.trim() !== '') {
                                  handleReplyComment(comment?.feed_id, comment?.comment_id, e.target.value, idx);
                                  e.target.value = '';
                                  setReplyingToIndex(null); // hide input after replying
                                }
                              }}
                            /> */}
                            </>
                          )}
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
              )}


            </CardContent>
          </Card>
        ))
      }
      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      <PostJobViewModal
        open={viewJobModalOpen}
        onClose={handleViewJobModalClose}
      />
      <PostInternshipViewModal
        open={viewInternshipModalOpen}
        onClose={handleViewInternshipModalClose}
      />
    </Box >
  );
};

export default PostBox;
